import { useNavigate, useLocation } from 'react-router-dom'
import AlertBell from './AlertBell'

export default function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()

  const items = [
    { path: '/',             icon: '📓', label: 'Notebook' },
    { path: '/participants', icon: '👥', label: 'People' },
    { path: '/dashboard',    icon: '📊', label: 'Dashboard' },
    { path: '/celebrations', icon: '🌟', label: 'Celebrate' },
    { path: '/more',         icon: '☰', label: 'More' },
  ]

  const activePath = location.pathname

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 flex justify-around py-2 z-40">
      {items.map(item => {
        const isActive = item.path === '/'
          ? activePath === '/' || activePath.startsWith('/log') || activePath.startsWith('/activity') || activePath.startsWith('/session')
          : activePath.startsWith(item.path)
        return (
          <button key={item.path} onClick={() => navigate(item.path)}
            className={`flex flex-col items-center pt-1 flex-1 transition-colors ${isActive ? 'text-teal-700' : 'text-stone-400'}`}>
            <span className="text-xl">{item.icon}</span>
            <span className={`text-xs mt-0.5 ${isActive ? 'font-semibold' : ''}`}>{item.label}</span>
          </button>
        )
      })}
      {/* AlertBell — login-notifications widget. Sits as a 6th item in
          the row, styled to match. Self-renders null when no auth user. */}
      <AlertBell />
    </div>
  )
}
